module.exports = __webpack_public_path__ + "static/btn 2_000010.0333958a.png";